import { isUseCaseBoardCopyingPage } from './validate-url.js';

export const usecaseBoardCopyingPageRouter = (data) => {
  return new Promise(function(resolve, reject) {
    if(isUseCaseBoardCopyingPage(data.path)) {
      data.page = {
        name: 'USE_CASE_BOARD_COPYING',
        params: data.params
      };
      resolve(data);
      return;
    }
    reject(data);
  });
}